import {match, Pattern} from 'ts-pattern';

import type {DocumentSourceResponseBody} from '@dms/api/finance';
import {accountingRoutes, businessCaseRoutes, workshopRoutes} from '@dms/routes';

import {composePath} from 'shared/web';

interface GetCustomerInsightsInvoiceHrefArgs {
  invoiceId: string;
  documentSource: DocumentSourceResponseBody | undefined;
  canReadBusinessCases: boolean;
  canReadServiceCases: boolean;
}

export function getCustomerInsightsInvoiceHref(args: GetCustomerInsightsInvoiceHrefArgs): string {
  const moduleSourceId = args.documentSource?.moduleSourceId;

  return match({
    moduleSource: args.documentSource?.moduleSource,
    moduleSourceId,
    canReadBusinessCases: args.canReadBusinessCases,
    canReadServiceCases: args.canReadServiceCases,
  })
    .with(
      {
        moduleSource: 'business-case',
        moduleSourceId: Pattern.string.minLength(1),
        canReadBusinessCases: true,
      },
      ({moduleSourceId}) => composePath(businessCaseRoutes.overview, {params: {id: moduleSourceId}})
    )
    .with(
      {
        moduleSource: 'service-case',
        moduleSourceId: Pattern.string.minLength(1),
        canReadServiceCases: true,
      },
      ({moduleSourceId}) =>
        composePath(workshopRoutes.serviceCaseDetail, {params: {id: moduleSourceId}})
    )
    .with(Pattern._, () =>
      composePath(accountingRoutes.invoiceDetail, {params: {id: args.invoiceId}})
    )
    .exhaustive();
}
